import { fNumber } from 'common/utils/formatNumber'
import React, { ReactNode } from 'react'
import { ControllerRenderProps } from 'react-hook-form'

import TextField from '@mui/material/TextField'

const IntegerTextField = ({
  field,
  error,
  helperText,
  endAdornment,
  disabled,
}: {
  field: ControllerRenderProps<any, any>
  error: boolean
  helperText?: ReactNode
  endAdornment?: ReactNode
  disabled?: boolean
}) => {
  const toDigits = (s: string) => s.replace(/[^0-9]/g, '')
  const formatIntegerView = (val: unknown) => {
    if (val === undefined || val === null || val === '') return ''
    const digits = String(val).replace(/,/g, '')
    return digits ? fNumber(digits, { disabledDecimal: true }) : ''
  }

  return (
    <TextField
      {...field}
      fullWidth
      size="small"
      type="text"
      inputMode="numeric"
      value={formatIntegerView(field.value)}
      onChange={(e) => {
        const raw = toDigits(e.target.value)
        field.onChange(raw)
      }}
      error={error}
      helperText={helperText}
      InputProps={{ endAdornment }}
      disabled={disabled}
    />
  )
}

export default IntegerTextField
